
	import { Component, Prop, Vue } from "vue-facing-decorator";

    @Component({})
	export default class HelloWorld extends Vue {
        @Prop() msg!: string;
	}
